import { useEffect } from 'react';
import { motion } from 'motion/react';
import { LEVELS } from '../../constants/levels.js';
import { getLevelName, getParentDescription, getReadingStage } from '../../config/levelConfig.js';
import { rqConfettiBurst } from '../../lib/animations.js';
import { popIn } from '../../lib/motionPresets.js';

export function LevelUpCeremony({level, onDismiss}) {
  const lv = LEVELS[level] || LEVELS[3];
  const levelName = getLevelName(level);
  const readingStage = getReadingStage(level);
  const parentDescription = getParentDescription(level);
  useEffect(() => {
    rqConfettiBurst({count:60,spread:90,y:0.5});
    setTimeout(() => rqConfettiBurst({count:30,spread:60,y:0.3}), 400);
    const t = setTimeout(onDismiss, 3000);
    return () => clearTimeout(t);
  }, []);
  return (
    <motion.div onClick={onDismiss} className="fixed inset-0 z-[9998] flex cursor-pointer items-center justify-center bg-black/75 backdrop-blur-sm" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.div {...popIn} className="flex flex-col items-center rounded-finley-xl border border-white/10 bg-white/10 px-10 py-12 text-center shadow-finley-lg">
        <motion.div className="mb-4 text-8xl" initial={{ scale: 0, rotate: -10 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: 'spring', stiffness: 300, damping: 8, delay: 0.2 }}>🐬</motion.div>
        <motion.h1 className="font-finley-display text-5xl font-bold text-white [text-shadow:0_4px_20px_rgba(0,0,0,0.3)]" initial={{ scale: 0, rotate: -10 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: 'spring', stiffness: 300, damping: 8, delay: 0.2 }}>
          {levelName}!
        </motion.h1>
        <motion.div className="mt-3 font-finley-display text-2xl" style={{ color: lv.color }} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}>
          {readingStage?.stageName || lv.name}
        </motion.div>
        <motion.div className="mt-2 text-base text-white/80" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
          {parentDescription || `Reading at ${lv.grade} level`}
        </motion.div>
        <motion.div className="mt-6 text-sm text-white/50" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }}>
          Tap to continue
        </motion.div>
      </motion.div>
    </motion.div>
  );
}
